import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNotificationsStore = defineStore('notifications', () => {
  const unreadCount = ref(0);

  function setUnreadCount(count: number) {
    unreadCount.value = count;
  }

  function clearUnreadCount() {
    unreadCount.value = 0;
  }

  return {
    unreadCount,
    setUnreadCount,
    clearUnreadCount
  };
});
